import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var LuggageAndBriefcaseIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 2a1 1 0 00-1-1H5l-.117.007A1 1 0 005 3v3H4l-.176.005A3 3 0 001 9v9l.006.195a3.001 3.001 0 002.001 2.636A2 2 0 107 21c.667 0 1-.334 1-1.002 0-.668-.333-1-1-.998H4l-.117-.007A1 1 0 013 18V9l.007-.117A1 1 0 014 8l8.388.002c.132.008.217.042.393.137l.211.115c.33.1.644.043.941-.17.446-.318.505-.857.306-1.152C14.039 6.637 13.598 6 12 6h-1V3l.117-.007A1 1 0 0012 2zm6.994 8.746c-.088-1.281-1.174-2.07-2.497-2.07h-2l-.171.004C13.025 8.748 12 9.593 12 10.916v.568h-1.5l-.164.006A2.5 2.5 0 008 13.984v.712l.007.192c.04.508.231.98.536 1.364L8.544 20l.005.176A3 3 0 0011.544 23h8.015l.176-.005A3 3 0 0022.559 20v-3.885c.28-.407.441-.898.441-1.419v-.712l-.005-.164a2.5 2.5 0 00-2.495-2.336H19v-.568l-.006-.17zm1.563 6.533L18 18.008v.492a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-.492l-2.457-.7.001 2.692a1 1 0 00.883.993l.117.007h8.015a1 1 0 00.993-.883l.007-.117-.002-2.721zM10.5 13.484h10l.09.008a.5.5 0 01.41.492v.712l-.007.082a.5.5 0 01-.356.399l-2.98.848A.5.5 0 0017.5 16h-4a.5.5 0 00-.156.025l-2.981-.848-.077-.03a.5.5 0 01-.286-.451v-.712l.008-.09a.5.5 0 01.492-.41zm6.227-2.808l-2.406-.002c-.164.001-.286.021-.314.168l-.007.074v.568h3v-.568c0-.194-.111-.234-.273-.24zM7 3h2v3H7V3z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
LuggageAndBriefcaseIcon.isCarinaIcon = true;
export default LuggageAndBriefcaseIcon;
